<template>
  <div class="container" v-loading.fullscreen.lock="fullscreenLoading">
    <sideBar class="vertical-menu"> </sideBar>
    <div class="container-wrapper" :class="{fold: sideBarFold}">
      <headerBar></headerBar>
      <div class="app-body">
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import {apiGetAllMachineList, apiGetEateryList} from '@/api';
import {errorMessage, successMessag} from '@/lib/msg.js';
import sideBar from './sideBar';
import headerBar from './headerBar';
import moment from 'moment';

export default {
  name: "admin",
  data() {
    return {
      permission: [],
      serverPointList: [],
      serverPointDialogShow: false,
      activeIndex: "",
      eateryList: [],
      canteenList: [],
      routeName: "",
      isCollapse: true,
      downloadImageListShow: false
    };
  },
  components: {
    sideBar,
    headerBar
  },
  created() {},
  mounted() {
    console.log(this.$router.options);
    if (!this.$route.name || this.$route.name === "admin") {
      if (this.username === "data_search") {
        this.activeIndex = "dishModelManagement";
      }
      if (this.userGroup === 1000) {
        this.activeIndex = "taskAdmin";
      }
      if (this.userGroup < 100 || this.userGroup === 100) {
        this.activeIndex = "taskAdmin";
      }
      if (this.userGroup === 200) {
        this.activeIndex = "canteenAdmin";
      }
      if (this.userGroup === 300) {
        this.activeIndex = "machineAdmin";
        this.toggleSubMenu(false);
      }
    }
    this.setAllCanteenList();
    this.getEateryList();
    this.getMachineList();
    this.emitLoading(500);
    // this.setUncheckedDishList();
    // 获取任务列表
    // if (this.userGroup !== 1) {
    //   this.getDetectedUnCheckRemindList();
    //   this.getBackDataUnCheckRemindList();
    //   this.getDataCollectCheckRemind()
    // }
    setTimeout(() => {
      if (this.$route.query.hasOwnProperty("lastRoutesName")) {
        this.$router.push({
          name: this.lastRoutesName
        });
      } else {
        this.$router.push({
          name: this.activeIndex
        });
      }
      this.removeLoading();
    }, 500);
  },
  computed: {
    ...mapGetters([
      "fullscreenLoading",
      "listQuery",
      "uncheckedDishList",
      "subMenuShow",
      "dataCollectCheckRemindList",
      'sideBarFold'
    ]),
    isMarketing() {
      return this.userinfo.username === "market" && this.userGroup === 300;
    },
    userinfo() {
      return this.$store.getters.userinfo();
    },
    ...mapState({
      loginMessage(state) {
        return state.admin.loginMessage;
      }
    }),

    userGroup() {
      return this.userinfo.userGroup;
    },
    username() {
      return this.userinfo.username;
    },
    lastRoutesName() {
      return this.$route.query.lastRoutesName || this.activeIndex;
    }
  },
  filters: {
    tsToDate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    ...mapActions([
      "setCanteenList",
      "setUncheckedDishList",
      "getDetectedUnCheckRemindList",
      "toggleSubMenu",
      "getBackDataUnCheckRemindList",
      "getDataCollectCheckRemind",
      "setListQuery",
      "setAllCanteenList",
    ]),
    ...mapMutations([
      "setListQuery",
      "emitLoading",
      "removeLoading",
      "clearImages",
      "setAllMachineList"
    ]),
    async getMachineList() {
      try {
        const res = await apiGetAllMachineList();
        const allMachineList = res.machine_info_list;
        this.setAllMachineList(allMachineList);
      } catch (e) {}
    },
    getEateryList() {
      apiGetEateryList({ apiKey: this.userinfo.api_key })
        .then(res => {
          if (res.state_code === 0) {
            this.eateryList = res.data.eatery_list;
            this.listQuery.eatery = this.eateryList[0];
            this.$store.commit("setEateryList", res.data.eatery_list);
            this.setListQuery(this.listQuery);
            this.setCanteenList();
          } else {
            return Promise.reject(new Error("查询食堂列表出错"));
          }
        })
        .catch(e => {
          errorMessage(e);
        });
    },
    setting() {
      this.$router.push({ name: "canteenAdmin" });
    },
    environment() {
      let baseUrl = process.env.BASE_URL;
      console.log(baseUrl);
      return baseUrl;
      if (baseUrl.indexOf("47")) {
        return true;
      } else {
        return false;
      }
    },
    tsTTodate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    }
  },
  watch: {
    // $route(to, from) {
    //   this.$refs.menu.activeIndex = to.name;
    // }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  .vertical-menu {
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
  }
  .container-wrapper {
    margin-left: 200px;
    width: calc(100vw - 200px);
    transition: margin-left .5s;
    &.fold {
      margin-left: 65px;
      width: calc(100vw - 65px);
    }
    .app-body {
      padding-left: 5px;
      height: calc(100vh - 40px);
    }
  }
}
</style>
